<template>
  <div class="animated fadeIn list-of-tranbank">
    <b-card>
      <div slot="header">My Cash-Advance Outstanding
        <div class="card-header-actions">
         <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col lg="6">
            <b-input-group >
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value" :state="!$v.tblData.DimVal.$error"></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="lkuDimShow=true">
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>

              </b-input-group>
        </b-col>
        <b-col lg="4">
          <b-input-group>
            <b-input-group-prepend class="py-2">
                  <div>
                    <b-form-checkbox v-model="allDim" value="1" unchecked-value="0">
                      All Dimension
                    </b-form-checkbox>
                  </div>
            </b-input-group-prepend>
            <b-button class="btn btn-success" @click="getData()" > <i class="fa fa-play"></i> Process</b-button>
          </b-input-group>
        </b-col>
      </b-row>
      <b-card no-body>
            <b-row v-if="(filterShow=='Hide')">
                <b-col lg="4">
                    <b-form-group
                        label="Filter"
                        label-cols-sm="1"
                        label-size="sm"
                        label-for="filterInput"
                        class="mb-0"
                        >
                        <b-input-group size="sm">
                            <b-form-input
                            v-model="filter"
                            type="search"
                            id="filterInput"
                            placeholder="Type to Search"
                            ></b-form-input>
                            <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>  
                </b-col> 
                <b-col lg="5">
                  <b-form-group
                    label="Filter On"
                    label-cols-sm="1"
                    label-size="sm"
                    description="Leave all unchecked to filter on all data"
                    class="mb-0">
                    <b-form-checkbox-group v-model="filterOn" class="mt-1">
                      <b-form-checkbox value="custinfo">Customer</b-form-checkbox>
                      <b-form-checkbox value="uraian">Description</b-form-checkbox>
                      <b-form-checkbox value="nomor">Invoice No.</b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-form-group>                
                </b-col>                 
                <b-col lg="3">
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                          <b> {{ filterShow }}</b> Filter
                        </b-form-checkbox>
                </b-col>         
            </b-row>
            <b-table
                class="mb-0"
                ref="tableOri"
                sticky-header="600px" outlined responsive striped hover
                style="font-size:smaller;"
                :items="rptLines"
                :fields="tblFields"
                :current-page="tblData.page"
                :per-page="tblData.limit"
                :sort-by.sync="tblData.sortBy"
                :sort-desc.sync="tblData.sortDesc"
                :filter="filter"
                :filterIncludedFields="filterOn"
                @filtered="onFiltered"                
            >
            <template v-slot:cell(tglPaym)="data">
              {{ data.item.tglPaym | moment("DD MMM YYYY") }}
            </template>
            <template v-slot:cell(nomor)="data">
              {{ data.item.nomor}}<br> | {{data.item.nomorPaym}}
            </template>
              <template v-slot:cell(nilaiByr)="data">
                  {{data.item.nilaiByr | numFormat}}
              </template>

              <template v-slot:cell(outstand)="data">
                {{data.item.outstand | numFormat}}
              </template>
            </b-table>
            <b-row class="mt-2">
                <b-col cols="4">
                    <div style="font-weight: bold;" class="ml-1">Total Outstanding : {{uanguser}}
                        <div style="text-align:right; border:1px solid silver; width:200px;height:40px;border-top: 1px solid #000 ;border-bottom: 2px solid #000; background: #e6e6e6; display:inline;" class="pl-2 pt-2 pr-2">
                          {{subtotal.totalOst | numFormat('0,0.00')}}</div>
                    </div>
                </b-col>
                <b-col cols="8">
                    <b-row >
                      <b-col cols="6" style="text-align:center">
                        <div>
                          Showing {{(tblData.page - 1) * tblData.limit + 1}}
                          to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
                          of {{tblData.total}} entries,   <span class="ml-3 mr-1">limit per page :</span> 
                          <select  v-model="tblData.limit"  style="width:60px;">
                            <option>10</option>
                            <option>15</option>
                            <option>20</option>                            
                            <option>25</option>
                            <option>30</option>                            
                          </select>
                        </div>
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                          <b> {{ filterShow }}</b>  Filter
                        </b-form-checkbox>
                      </b-col>
                      <b-col cols="6">            
                        <b-pagination 
                          align="right"
                          :total-rows="tblData.total"
                          :per-page="tblData.limit"
                          v-model="tblData.page"
                        ></b-pagination>
                      </b-col>
                    </b-row>
                </b-col>
            </b-row>
      </b-card>
  </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
        <b-modal v-model="lkuDimShow" size="lg" :hide-footer="true" title="List of Dimension Value" :centered="true" >
            <lku-dim @click="onSelectedDim" :DimColName="tblData.DimCol" :key="tblData.DimCol"></lku-dim>
        </b-modal>        

  </div>
</template>

<style lang="scss" scoped>
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;

        table {
            font-size: smaller;
            th {
                border-bottom: 1px solid #D1D1D1;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            td {
                border-bottom: 1px solid #f5f5f5;
                padding: 0 10px;
                height: 25px;
            }

            tr.selisih {
              background: yellow;
            }
            
            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
            
            td.total {
                border-top: 2px solid #000 !important;
                background: #e6e6e6 !important;
            }
            
            td.grdtotal {
                border-top: 2px solid #000!important;
                border-bottom: 2px double #000 !important;
                background: #e6e6e6 !important;
            }
        }
    }
 
</style>

<script>
import moment from 'moment';
import advance from "../../apis/advance";
import Loading from 'vue-loading-overlay';
import lkuDim from "../lookup/lkuDim";

import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    tblData: {
        DimVal: { required:requiredIf(function () {
          return !this.isOptionalDimCol
        })  },
        DimCol: { required }
    },
  }, 
  data() {
    return {
      lkuDimShow: false,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      filterShow:'Show',
      uanguser: this.$store.state.user.matauang,
      rptLines : [],
      subtotal : {},
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'tglPaym',
        sortDesc: false, outstand:'', DimCol:'Dim1',DimVal:'',
        crewkey:this.$store.state.user.crewkey,crewinfo:this.$store.state.user.full_name
      },
      filter: null,
      filterOn: [],  
      allDim: 0,
    };
  },
  components: { Loading, lkuDim},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },  
    tblFields(){
      const fields=[
          {
            key: "advAccName",
            label: "Account",
            thStyle: "width:120px",
            sortable: true
          },
          {
            key: "keterangan",
            label: "Description",
          },
          {
            key: "crewinfo",
            label: "Request By",
            sortable: true
          },
          {
            key: "nomor",
            label: "Request# | Payment# ",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "dibayarke",
            label: "Paid to",
            sortable: true
          },
          {
            key: "tglPaym",
            thStyle: "width:90px",
            label: "Payment Date",
            thClass: "text-center",
            tdClass: "text-center"

          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true
          },
          {
            key: "nilaiByr",
            label: "Payment Amount",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right"
          },
          {
            key: "outstand",
            label: "Un-Settle Amount",
            thStyle: "width:130px",
            thClass: "text-right",
            tdClass: "text-right"
          },
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: `${dims[i].value}Txt`,
            thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }
      return fields;
    },

    invalidFilter() {
      this.$v.tblData.$touch();
      return this.$v.tblData.$invalid;
    },
    isOptionalDimCol(){
      return this.allDim==1;
    }
  },
  watch:{
    "tblData.DimCol": function(newval) {
        this.tblData.DimVal='';
        this.tblData.DimValCode='';
        // this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
  },  
  methods: {
    onSelectedDim: function(_selected){
        this.tblData.DimVal=_selected.nama;
        this.tblData.DimValCode=_selected.kode;
        this.tblData.DimValInfo=`${_selected.kode.trim()} | ${_selected.nama}`;
          this.$forceUpdate();
        this.lkuDimShow=false;
    },    
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },      
    getData: async function(ctx) {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
        this.tblData.DimColInfo=this.dimension.find(d => d.value == this.tblData.DimCol).text;
        this.isLoading=true;
        this.rptLines = await advance.outstand(this.tblData);
        this.tblData.total = this.rptLines.length;        
        this.subtotal.totalOst = this.rptLines.reduce((a, b) => a + (b.nilaiBank*b.kursPaym), 0);
        this.isLoading=false;      
       }
    },
    exportxls: async function() {
      if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
      } else {
        this.isLoading=true;
        try {
            this.tblData.DimColInfo=(this.dimension.find(d => d.value === this.tblData.DimCol) || {}).text;
            toastr.info('Export to XLS ');
            const response = await advance.outstandexport(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
      }
    },    
    close(){
      router.push("home");
    }
  }
};
</script>
